import Pqp from "../3x1010/Pqp.js";

/**
 * @param {string} string
 * @param {boolean} removeDiacritics - if true normalizes token without diacritics 
 * 
 * @returns an array of normalized strings (tokens)
 * */
export function stringToTokenList(string, removeDiacritics) {
  return string
    .trim()
    .split(" ")
    .filter(s => s.length)
    .map(s => removeDiacritics
      ? Pqp.removeDiacritics(s.toLowerCase())
      : s.toLowerCase()
    );
}
